import Vue from 'vue';
import Router from 'vue-router';
import { interopDefault } from './utils';

const _085be7ce = () => interopDefault(import('../pages/monitoring.vue'
/* webpackChunkName: "pages/monitoring" */
));

const _5ba04bc6 = () => interopDefault(import('../pages/redirect_url.vue'
/* webpackChunkName: "pages/redirect_url" */
));

const _4695c1cb = () => interopDefault(import('../pages/tools/grid.vue'
/* webpackChunkName: "pages/tools/grid" */
));

const _61378fc5 = () => interopDefault(import('../pages/_market/_language/index.vue'
/* webpackChunkName: "pages/_market/_language/index" */
));

const _158798fd = () => interopDefault(import('../pages/_market/_language/cart.vue'
/* webpackChunkName: "pages/_market/_language/cart" */
));

const _446f0ca1 = () => interopDefault(import('../pages/_market/_language/help/index.vue'
/* webpackChunkName: "pages/_market/_language/help/index" */
));

const _2adf32dc = () => interopDefault(import('../pages/_market/_language/login.vue'
/* webpackChunkName: "pages/_market/_language/login" */
));

const _0c84bbd2 = () => interopDefault(import('../pages/_market/_language/lost-password.vue'
/* webpackChunkName: "pages/_market/_language/lost-password" */
));

const _0c717076 = () => interopDefault(import('../pages/_market/_language/reset-password.vue'
/* webpackChunkName: "pages/_market/_language/reset-password" */
));

const _7d6115b5 = () => interopDefault(import('../pages/_market/_language/signup.vue'
/* webpackChunkName: "pages/_market/_language/signup" */
));

const _3980d7eb = () => interopDefault(import('../pages/_market/_language/sitemap/index.vue'
/* webpackChunkName: "pages/_market/_language/sitemap/index" */
));

const _4f9a9460 = () => interopDefault(import('../pages/_market/_language/store-locator/index.vue'
/* webpackChunkName: "pages/_market/_language/store-locator/index" */
));

const _886af6aa = () => interopDefault(import('../pages/_market/_language/user/index.vue'
/* webpackChunkName: "pages/_market/_language/user/index" */
));

const _2f731c62 = () => interopDefault(import('../pages/_market/_language/help/confirm.vue'
/* webpackChunkName: "pages/_market/_language/help/confirm" */
));

const _3155563b = () => interopDefault(import('../pages/_market/_language/help/deliveryConfirm.vue'
/* webpackChunkName: "pages/_market/_language/help/deliveryConfirm" */
));

const _47eb3fe8 = () => interopDefault(import('../pages/_market/_language/s/catalogue-luminaires.vue'
/* webpackChunkName: "pages/_market/_language/s/catalogue-luminaires" */
));

const _e28a1b4e = () => interopDefault(import('../pages/_market/_language/s/home-by-me.vue'
/* webpackChunkName: "pages/_market/_language/s/home-by-me" */
));

const _0dddf176 = () => interopDefault(import('../pages/_market/_language/s/lighting.vue'
/* webpackChunkName: "pages/_market/_language/s/lighting" */
));

const _fa9dfe7c = () => interopDefault(import('../pages/_market/_language/s/sustainable-development.vue'
/* webpackChunkName: "pages/_market/_language/s/sustainable-development" */
));

const _eaabd592 = () => interopDefault(import('../pages/_market/_language/t/confirmed.vue'
/* webpackChunkName: "pages/_market/_language/t/confirmed" */
));

const _69d3e77e = () => interopDefault(import('../pages/_market/_language/t/login.vue'
/* webpackChunkName: "pages/_market/_language/t/login" */
));

const _f5e97308 = () => interopDefault(import('../pages/_market/_language/t/lost-password.vue'
/* webpackChunkName: "pages/_market/_language/t/lost-password" */
));

const _1aedef44 = () => interopDefault(import('../pages/_market/_language/t/payment.vue'
/* webpackChunkName: "pages/_market/_language/t/payment" */
));

const _ec223878 = () => interopDefault(import('../pages/_market/_language/t/payment-paypal-canceled.vue'
/* webpackChunkName: "pages/_market/_language/t/payment-paypal-canceled" */
));

const _1299ed88 = () => interopDefault(import('../pages/_market/_language/t/payment-paypal-pending.vue'
/* webpackChunkName: "pages/_market/_language/t/payment-paypal-pending" */
));

const _0070f7b0 = () => interopDefault(import('../pages/_market/_language/t/refused.vue'
/* webpackChunkName: "pages/_market/_language/t/refused" */
));

const _67174a86 = () => interopDefault(import('../pages/_market/_language/t/shipping.vue'
/* webpackChunkName: "pages/_market/_language/t/shipping" */
));

const _37f52e20 = () => interopDefault(import('../pages/_market/_language/t/signup.vue'
/* webpackChunkName: "pages/_market/_language/t/signup" */
));

const _3a3d3282 = () => interopDefault(import('../pages/_market/_language/user/gift-card-download.vue'
/* webpackChunkName: "pages/_market/_language/user/gift-card-download" */
));

const _58b4c306 = () => interopDefault(import('../pages/_market/_language/user/gift-cards.vue'
/* webpackChunkName: "pages/_market/_language/user/gift-cards" */
));

const _7fb31b42 = () => interopDefault(import('../pages/_market/_language/user/orders/index.vue'
/* webpackChunkName: "pages/_market/_language/user/orders/index" */
));

const _2697d47c = () => interopDefault(import('../pages/_market/_language/user/profile.vue'
/* webpackChunkName: "pages/_market/_language/user/profile" */
));

const _ba547a76 = () => interopDefault(import('../pages/_market/_language/user/profile/index.vue'
/* webpackChunkName: "pages/_market/_language/user/profile/index" */
));

const _55b0efd6 = () => interopDefault(import('../pages/_market/_language/user/profile/addresses.vue'
/* webpackChunkName: "pages/_market/_language/user/profile/addresses" */
));

const _01789cb4 = () => interopDefault(import('../pages/_market/_language/user/profile/alerts.vue'
/* webpackChunkName: "pages/_market/_language/user/profile/alerts" */
));

const _5a986578 = () => interopDefault(import('../pages/_market/_language/user/profile/password.vue'
/* webpackChunkName: "pages/_market/_language/user/profile/password" */
));

const _51dce7fc = () => interopDefault(import('../pages/_market/_language/user/wishlist.vue'
/* webpackChunkName: "pages/_market/_language/user/wishlist" */
));

const _3c015e0c = () => interopDefault(import('../pages/_market/_language/help/merchant/confirm.vue'
/* webpackChunkName: "pages/_market/_language/help/merchant/confirm" */
));

const _781a9517 = () => interopDefault(import('../pages/_market/_language/configurator/product/_model.vue'
/* webpackChunkName: "pages/_market/_language/configurator/product/_model" */
));

const _08e64a16 = () => interopDefault(import('../pages/_market/_language/e/magazine/_slug.vue'
/* webpackChunkName: "pages/_market/_language/e/magazine/_slug" */
));

const _6c87f2c3 = () => interopDefault(import('../pages/_market/_language/help/contact/_form.vue'
/* webpackChunkName: "pages/_market/_language/help/contact/_form" */
));

const _15675473 = () => interopDefault(import('../pages/_market/_language/help/faq/_answer.vue'
/* webpackChunkName: "pages/_market/_language/help/faq/_answer" */
));

const _0bf6ae85 = () => interopDefault(import('../pages/_market/_language/help/return/_form.vue'
/* webpackChunkName: "pages/_market/_language/help/return/_form" */
));

const _00dc878f = () => interopDefault(import('../pages/_market/_language/user/orders/_reference.vue'
/* webpackChunkName: "pages/_market/_language/user/orders/_reference" */
));

const _f61a51cc = () => interopDefault(import('../pages/_market/_language/help/merchant/_order/_reference/contact/index.vue'
/* webpackChunkName: "pages/_market/_language/help/merchant/_order/_reference/contact/index" */
));

const _0be98aa5 = () => interopDefault(import('../pages/_market/_language/help/merchant/_order/_reference/messages.vue'
/* webpackChunkName: "pages/_market/_language/help/merchant/_order/_reference/messages" */
));

const _c75ecb4a = () => interopDefault(import('../pages/_market/_language/help/merchant/_order/_reference/notation.vue'
/* webpackChunkName: "pages/_market/_language/help/merchant/_order/_reference/notation" */
));

const _4cd96a18 = () => interopDefault(import('../pages/_market/_language/help/merchant/_order/_reference/contact/product/_code.vue'
/* webpackChunkName: "pages/_market/_language/help/merchant/_order/_reference/contact/product/_code" */
));

const _f284efd8 = () => interopDefault(import('../pages/_market/_language/help/merchant/_order/_reference/contact/_code.vue'
/* webpackChunkName: "pages/_market/_language/help/merchant/_order/_reference/contact/_code" */
));

const _f36d9d4c = () => interopDefault(import('../pages/_market/_language/c/_alias.vue'
/* webpackChunkName: "pages/_market/_language/c/_alias" */
));

const _6a93b0f7 = () => interopDefault(import('../pages/_market/_language/configurator/_model.vue'
/* webpackChunkName: "pages/_market/_language/configurator/_model" */
));

const _f625203e = () => interopDefault(import('../pages/_market/_language/inspirations/_slug.vue'
/* webpackChunkName: "pages/_market/_language/inspirations/_slug" */
));

const _598cb1e0 = () => interopDefault(import('../pages/_market/_language/m/_alias.vue'
/* webpackChunkName: "pages/_market/_language/m/_alias" */
));

const _2b62d1a6 = () => interopDefault(import('../pages/_market/_language/p/_alias.vue'
/* webpackChunkName: "pages/_market/_language/p/_alias" */
));

const _66c3f6a5 = () => interopDefault(import('../pages/_market/_language/q/_keyword.vue'
/* webpackChunkName: "pages/_market/_language/q/_keyword" */
));

const _310aef53 = () => interopDefault(import('../pages/_market/_language/e/_alias/_slug.vue'
/* webpackChunkName: "pages/_market/_language/e/_alias/_slug" */
));

const _d3e9a946 = () => interopDefault(import('../pages/_market/_language/index.vue'
/* webpackChunkName: "" */
));

const _63bd6b49 = () => interopDefault(import('../pages/_market/_language/inspirations/_slug.vue'
/* webpackChunkName: "" */
));

const _52a6eaad = () => interopDefault(import('../pages/_market/_language/s/lighting.vue'
/* webpackChunkName: "" */
));

const _4b34c87e = () => interopDefault(import('../pages/_market/_language/s/home-by-me.vue'
/* webpackChunkName: "" */
));

const _3cb0debb = () => interopDefault(import('../pages/_market/_language/e/_alias/_slug.vue'
/* webpackChunkName: "" */
));

const _4aca05f8 = () => interopDefault(import('../pages/_market/_language/store-locator/index.vue'
/* webpackChunkName: "" */
));

Vue.use(Router);

if (process.client) {
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual'; // reset scrollRestoration to auto when leaving page, allowing page reload
    // and back-navigation from other pages to use the browser to restore the
    // scrolling position.

    window.addEventListener('beforeunload', () => {
      window.history.scrollRestoration = 'auto';
    }); // Setting scrollRestoration to manual again when returning to this page.

    window.addEventListener('load', () => {
      window.history.scrollRestoration = 'manual';
    });
  }
}

const scrollBehavior = function scrollBehavior(to, from, savedPosition) {
  // if the returned position is falsy or an empty object,
  // will retain current scroll position.
  let position = false; // if no children detected and scrollToTop is not explicitly disabled

  if (to.matched.length < 2 && to.matched.every(r => r.components.default.options.scrollToTop !== false)) {
    // scroll to the top of the page
    position = {
      x: 0,
      y: 0
    };
  } else if (to.matched.some(r => r.components.default.options.scrollToTop)) {
    // if one of the children has scrollToTop option set to true
    position = {
      x: 0,
      y: 0
    };
  } // savedPosition is only available for popstate navigations (back button)


  if (savedPosition) {
    position = savedPosition;
  }

  return new Promise(resolve => {
    // wait for the out transition to complete (if necessary)
    window.$nuxt.$once('triggerScroll', () => {
      // coords will be used if no selector is provided,
      // or if the selector didn't match any element.
      if (to.hash) {
        let hash = to.hash; // CSS.escape() is not supported with IE and Edge.

        if (typeof window.CSS !== 'undefined' && typeof window.CSS.escape !== 'undefined') {
          hash = '#' + window.CSS.escape(hash.substr(1));
        }

        try {
          if (document.querySelector(hash)) {
            // scroll to anchor by returning the selector
            position = {
              selector: hash
            };
          }
        } catch (e) {
          console.warn('Failed to save scroll position. Please add CSS.escape() polyfill (https://github.com/mathiasbynens/CSS.escape).');
        }
      }

      resolve(position);
    });
  });
};

export function createRouter() {
  return new Router({
    mode: 'history',
    base: decodeURI('/'),
    linkActiveClass: 'nuxt-link-active',
    linkExactActiveClass: 'nuxt-link-exact-active',
    scrollBehavior,
    routes: [{
      path: "/monitoring",
      component: _085be7ce,
      name: "monitoring"
    }, {
      path: "/redirect_url",
      component: _5ba04bc6,
      name: "redirect_url"
    }, {
      path: "/tools/grid",
      component: _4695c1cb,
      name: "tools-grid"
    }, {
      path: "/:market/:language",
      component: _61378fc5,
      name: "market-language"
    }, {
      path: "/:market/:language/cart",
      component: _158798fd,
      name: "market-language-cart"
    }, {
      path: "/:market/:language/help",
      component: _446f0ca1,
      name: "market-language-help"
    }, {
      path: "/:market/:language/login",
      component: _2adf32dc,
      name: "market-language-login"
    }, {
      path: "/:market/:language/lost-password",
      component: _0c84bbd2,
      name: "market-language-lost-password"
    }, {
      path: "/:market/:language/reset-password",
      component: _0c717076,
      name: "market-language-reset-password"
    }, {
      path: "/:market/:language/signup",
      component: _7d6115b5,
      name: "market-language-signup"
    }, {
      path: "/:market/:language/sitemap",
      component: _3980d7eb,
      name: "market-language-sitemap"
    }, {
      path: "/:market/:language/store-locator",
      component: _4f9a9460,
      name: "market-language-store-locator"
    }, {
      path: "/:market/:language/user",
      component: _886af6aa,
      name: "market-language-user"
    }, {
      path: "/:market/:language/help/confirm",
      component: _2f731c62,
      name: "market-language-help-confirm"
    }, {
      path: "/:market/:language/help/deliveryConfirm",
      component: _3155563b,
      name: "market-language-help-deliveryConfirm"
    }, {
      path: "/:market/:language/s/catalogue-luminaires",
      component: _47eb3fe8,
      name: "market-language-s-catalogue-luminaires"
    }, {
      path: "/:market/:language/s/home-by-me",
      component: _e28a1b4e,
      name: "market-language-s-home-by-me"
    }, {
      path: "/:market/:language/s/lighting",
      component: _0dddf176,
      name: "market-language-s-lighting"
    }, {
      path: "/:market/:language/s/sustainable-development",
      component: _fa9dfe7c,
      name: "market-language-s-sustainable-development"
    }, {
      path: "/:market/:language/t/confirmed",
      component: _eaabd592,
      name: "market-language-t-confirmed"
    }, {
      path: "/:market/:language/t/login",
      component: _69d3e77e,
      name: "market-language-t-login"
    }, {
      path: "/:market/:language/t/lost-password",
      component: _f5e97308,
      name: "market-language-t-lost-password"
    }, {
      path: "/:market/:language/t/payment",
      component: _1aedef44,
      name: "market-language-t-payment"
    }, {
      path: "/:market/:language/t/payment-paypal-canceled",
      component: _ec223878,
      name: "market-language-t-payment-paypal-canceled"
    }, {
      path: "/:market/:language/t/payment-paypal-pending",
      component: _1299ed88,
      name: "market-language-t-payment-paypal-pending"
    }, {
      path: "/:market/:language/t/refused",
      component: _0070f7b0,
      name: "market-language-t-refused"
    }, {
      path: "/:market/:language/t/shipping",
      component: _67174a86,
      name: "market-language-t-shipping"
    }, {
      path: "/:market/:language/t/signup",
      component: _37f52e20,
      name: "market-language-t-signup"
    }, {
      path: "/:market/:language/user/gift-card-download",
      component: _3a3d3282,
      name: "market-language-user-gift-card-download"
    }, {
      path: "/:market/:language/user/gift-cards",
      component: _58b4c306,
      name: "market-language-user-gift-cards"
    }, {
      path: "/:market/:language/user/orders",
      component: _7fb31b42,
      name: "market-language-user-orders"
    }, {
      path: "/:market/:language/user/profile",
      component: _2697d47c,
      children: [{
        path: "",
        component: _ba547a76,
        name: "market-language-user-profile"
      }, {
        path: "addresses",
        component: _55b0efd6,
        name: "market-language-user-profile-addresses"
      }, {
        path: "alerts",
        component: _01789cb4,
        name: "market-language-user-profile-alerts"
      }, {
        path: "password",
        component: _5a986578,
        name: "market-language-user-profile-password"
      }]
    }, {
      path: "/:market/:language/user/wishlist",
      component: _51dce7fc,
      name: "market-language-user-wishlist"
    }, {
      path: "/:market/:language/help/merchant/confirm",
      component: _3c015e0c,
      name: "market-language-help-merchant-confirm"
    }, {
      path: "/:market/:language/configurator/product/:model?",
      component: _781a9517,
      name: "market-language-configurator-product-model"
    }, {
      path: "/:market/:language/e/magazine/:slug?",
      component: _08e64a16,
      name: "market-language-e-magazine-slug"
    }, {
      path: "/:market/:language/help/contact/:form?",
      component: _6c87f2c3,
      name: "market-language-help-contact-form"
    }, {
      path: "/:market/:language/help/faq/:answer?",
      component: _15675473,
      name: "market-language-help-faq-answer"
    }, {
      path: "/:market/:language/help/return/:form?",
      component: _0bf6ae85,
      name: "market-language-help-return-form"
    }, {
      path: "/:market/:language/user/orders/:reference?",
      component: _00dc878f,
      name: "market-language-user-orders-reference"
    }, {
      path: "/:market/:language/help/merchant/:order?/:reference/contact",
      component: _f61a51cc,
      name: "market-language-help-merchant-order-reference-contact"
    }, {
      path: "/:market/:language/help/merchant/:order?/:reference/messages",
      component: _0be98aa5,
      name: "market-language-help-merchant-order-reference-messages"
    }, {
      path: "/:market/:language/help/merchant/:order?/:reference/notation",
      component: _c75ecb4a,
      name: "market-language-help-merchant-order-reference-notation"
    }, {
      path: "/:market/:language/help/merchant/:order?/:reference/contact/product/:code?",
      component: _4cd96a18,
      name: "market-language-help-merchant-order-reference-contact-product-code"
    }, {
      path: "/:market/:language/help/merchant/:order?/:reference/contact/:code?",
      component: _f284efd8,
      name: "market-language-help-merchant-order-reference-contact-code"
    }, {
      path: "/:market/:language/c/:alias?",
      component: _f36d9d4c,
      name: "market-language-c-alias"
    }, {
      path: "/:market/:language/configurator/:model?",
      component: _6a93b0f7,
      name: "market-language-configurator-model"
    }, {
      path: "/:market/:language/inspirations/:slug?",
      component: _f625203e,
      name: "market-language-inspirations-slug"
    }, {
      path: "/:market/:language/m/:alias?",
      component: _598cb1e0,
      name: "market-language-m-alias"
    }, {
      path: "/:market/:language/p/:alias?",
      component: _2b62d1a6,
      name: "market-language-p-alias"
    }, {
      path: "/:market/:language/q/:keyword?",
      component: _66c3f6a5,
      name: "market-language-q-keyword"
    }, {
      path: "/:market/:language/e/:alias?/:slug?",
      component: _310aef53,
      name: "market-language-e-alias-slug"
    }, {
      path: "/",
      component: _d3e9a946,
      name: "market-language-home-fr"
    }, {
      path: "/:market/:language/inspirations*",
      component: _63bd6b49,
      name: "market-language-inspirations-fr"
    }, {
      path: "/:market/:language/inspirationen*",
      component: _63bd6b49,
      name: "market-language-inspirations-de"
    }, {
      path: "/:market/:language/ispirazione*",
      component: _63bd6b49,
      name: "market-language-inspirations-it"
    }, {
      path: "/:market/:language/inspiration*",
      component: _63bd6b49,
      name: "market-language-inspirations-en"
    }, {
      path: "/:market/:language/inspiration*",
      component: _63bd6b49,
      name: "market-language-inspirations-pt"
    }, {
      path: "/:market/:language/inspiracion*",
      component: _63bd6b49,
      name: "market-language-inspirations-es"
    }, {
      path: "/:market/:language/s/inspiratie*",
      component: _63bd6b49,
      name: "market-language-inspirations-nl"
    }, {
      path: "/:market/:language/s/luminaires*",
      component: _52a6eaad,
      name: "market-language-lighting-fr"
    }, {
      path: "/:market/:language/s/leuchten*",
      component: _52a6eaad,
      name: "market-language-lighting-de"
    }, {
      path: "/:market/:language/s/illuminazioni*",
      component: _52a6eaad,
      name: "market-language-lighting-it"
    }, {
      path: "/:market/:language/s/lighting*",
      component: _52a6eaad,
      name: "market-language-lighting-en"
    }, {
      path: "/:market/:language/s/lighting*",
      component: _52a6eaad,
      name: "market-language-lighting-pt"
    }, {
      path: "/:market/:language/s/lamparas*",
      component: _52a6eaad,
      name: "market-language-lighting-es"
    }, {
      path: "/:market/:language/s/verlichting*",
      component: _52a6eaad,
      name: "market-language-lighting-nl"
    }, {
      path: "/:market/:language/s/atelier-deco*",
      component: _4b34c87e,
      name: "market-language-home-by-me-fr"
    }, {
      path: "/:market/:language/s/atelier-arredo*",
      component: _4b34c87e,
      name: "market-language-home-by-me-it"
    }, {
      path: "/:market/:language/s/taller-de-decoracion*",
      component: _4b34c87e,
      name: "market-language-home-by-me-es"
    }, {
      path: "/:market/:language/s/dekowerkstatt*",
      component: _4b34c87e,
      name: "market-language-home-by-me-de"
    }, {
      path: "/:market/:language/s/decor-workshop*",
      component: _4b34c87e,
      name: "market-language-home-by-me-en"
    }, {
      path: "/:market/:language/:alias/:slug",
      component: _3cb0debb,
      name: "market-language-editorial"
    }, {
      path: "/:market/:language/magasins/",
      component: _4aca05f8,
      name: "store-locator"
    }],
    fallback: false
  });
}